import { MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';

import { environment } from '../../../../environments/environment';

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.auth.scopes]
    },
    loginFailedRoute: environment.auth.loginFailedRedirectUri
  };
}